import {
  UserProfileDeleteCcDocument,
  UserProfileDeleteCcMutationResult,
  UserProfileDeleteCcMutationVariables,
} from "@graphql/api";

export default async function userProfileDeleteCc(
  id: number,
  ccId?: string,
  ccRefId?: string,
  ccToken?: string,
  ccLast4?: string,
): Promise<boolean> {
  const client = global.window.apolloClient;

  const mutVars: UserProfileDeleteCcMutationVariables = { id, ccId, ccRefId, ccToken, ccLast4 };
  const result: UserProfileDeleteCcMutationResult = await client.mutate({
    mutation: UserProfileDeleteCcDocument,
    variables: mutVars,
  });

  if (result.data?.userProfileDeleteCc.success) {
    // Reload the Apollo cache.
    await client.resetStore();
  }

  return result.data?.userProfileDeleteCc.success;
}
